import { selector } from 'recoil';
import { sspSubmitOrder } from 'shared/store';

export const addReaderADGroup = selector({
    key: 'cosmos_addReaderADGroup',
    get: ({ get }) => get(sspSubmitOrder).nonPrivilegedADGroupList,
    set: ({ set, get }, count) => {
        const currentReaderADGroupList = get(sspSubmitOrder).nonPrivilegedADGroupList;
        let nonPrivilegedADGroupList = [null];
        nonPrivilegedADGroupList = [...currentReaderADGroupList, ...Array(count.count).fill({ readerValue: null })];

        set(sspSubmitOrder, {
            ...get(sspSubmitOrder),
            nonPrivilegedADGroupList,
        });
    },
});

export const removeReaderADGroup = selector({
    key: 'cosmos_removeReaderADGroup',
    get: ({ get }) => get(sspSubmitOrder).nonPrivilegedADGroupList,
    set: ({ set, get }, adGroupToRemove) => {
        const currentReaderADGroupList = get(sspSubmitOrder).nonPrivilegedADGroupList;
        const readerADGroupToRemoveIndex = currentReaderADGroupList.findIndex((val) => val === adGroupToRemove);
        const nonPrivilegedADGroupList = [
            ...currentReaderADGroupList.slice(0, readerADGroupToRemoveIndex),
            ...currentReaderADGroupList.slice(readerADGroupToRemoveIndex + 1),
        ];
        set(sspSubmitOrder, {
            ...get(sspSubmitOrder),
            nonPrivilegedADGroupList,
        });
    },
});

export const updateReaderADGroup = selector({
    key: 'cosmos_updateReaderADGroup',
    get: ({ get }) => get(sspSubmitOrder).nonPrivilegedADGroupList,
    set: ({ set, get }, params) => {
        const currentReaderADGroupList = get(sspSubmitOrder).nonPrivilegedADGroupList;
        if (params?.key === 'inputSelect') {
            const updatedReaderADGroup = { ...currentReaderADGroupList[params.index], readerValue: params.selectedValue.label };
            const nonPrivilegedADGroupList = [
                ...currentReaderADGroupList.slice(0, params?.index),
                updatedReaderADGroup,
                ...currentReaderADGroupList.slice(params?.index + 1),
            ];
            set(sspSubmitOrder, { ...get(sspSubmitOrder), nonPrivilegedADGroupList });
        }
        if (params?.key === 'inputChange') {
            const updatedReaderADGroup = { ...currentReaderADGroupList[params.index], readerInputValue: params.selectedValue };
            const nonPrivilegedADGroupList = [
                ...currentReaderADGroupList.slice(0, params?.index),
                updatedReaderADGroup,
                ...currentReaderADGroupList.slice(params?.index + 1),
            ];
            set(sspSubmitOrder, { ...get(sspSubmitOrder), nonPrivilegedADGroupList });
        }
    },
});
